import { addError } from 'monitor';

type TargetSpecification = {
  is_target?: boolean | null;
};

export const isTargetSpecification = <T extends TargetSpecification>(specification: T): boolean => {
  return specification.is_target === true;
};

export const getTargetSpecifications = <T extends TargetSpecification>(specifications?: readonly T[] | null): T[] => {
  return specifications?.filter(isTargetSpecification) ?? [];
};

export const getTargetSpecification = <T extends TargetSpecification>(
  specifications?: readonly T[] | null
): T | null => {
  const targetSpecs = getTargetSpecifications(specifications);
  if (targetSpecs.length > 1) {
    addError(Error('Multiple target specifications found. Expected only one.'), {
      specifications,
      targetSpecs,
    });
  }
  return targetSpecs[0] ?? null;
};
